export namespace NotificationTypes {
    export const BENUTZER_ZUGRIFF_UPDATED_NOTIFICATION = 'BENUTZER.ZUGRIFFUPDATED';
    export const COMMAND_FAILED_NOTIFICATION = 'COMMAND.FAILED';
    export const COMMAND_SUCCEEDED_NOTIFICATION = 'COMMAND.SUCCEEDED';
    export const READ_MODEL_UPDATED_NOTIFICATION = 'READMODEL.UPDATED';
    
}

